import { createAsyncThunk } from '@reduxjs/toolkit';

import { getClassificationClassListService } from 'services/classification_class.service';

export const getClassificationClassList = createAsyncThunk(
  'classificationClass/list',
  async (_, thunkApi) => {
    try {
      const response = await getClassificationClassListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
